import "./toggle-group.css.js";
const t = {
  modifiers: {
    compact: "pf-m-compact",
    selected: "pf-m-selected",
    disabled: "pf-m-disabled"
  },
  toggleGroup: "pf-v6-c-toggle-group",
  toggleGroupButton: "pf-v6-c-toggle-group__button",
  toggleGroupIcon: "pf-v6-c-toggle-group__icon",
  toggleGroupItem: "pf-v6-c-toggle-group__item",
  toggleGroupText: "pf-v6-c-toggle-group__text"
};
export {
  t as default
};
